<div class="content grid-1-auto md3-surface app-pad-top-none">
<div class="layout-auto-1-auto app-space-top md3-card-on-surface">
	<div class="app-space-right">
		<div class="grid-1-auto">
			<h5>{{getRessource('HeaderText')}} {{Data.leName}} ({{Data.leNr}})</h5>
			<div>
				<span class="chip app-chip-status"
				      *ngIf="!ServiceRecordSummary?.serviceRecordDetails?.isEmpty"
				      [ngClass]="getRessource('ServiceRecordStatusClass.' + ServiceRecordSummary?.serviceRecordDetails?.data?.leState)">
              {{getRessource('ServiceRecordStatus.' + ServiceRecordSummary?.serviceRecordDetails?.data?.leState)}}
        </span>
			</div>
		</div>
		<div class="typo-container-s-s-q typo-small" *ngIf="!ServiceRecordSummary?.serviceRecordDetails?.isEmpty">
			<span class="typo-small">{{getRessource('LVCreator')}}</span>
			<span>{{ServiceRecordSummary?.serviceRecordDetails?.data?.leCRU}}</span>
			<q></q>
			<span class="typo-small">{{getRessource('LVCreateDate')}}</span>
			<span>{{ServiceRecordSummary?.serviceRecordDetails?.data?.leCRD | excDate: 'dd.MM.yyyy'}}</span>
			<q></q>
			<ng-container *ngIf="ServiceRecordSummary?.serviceRecordDetails?.data?.leFirstDate">
				<span class="typo-small">{{getRessource('OutFirstDate')}}</span>
				<span>{{ServiceRecordSummary?.serviceRecordDetails?.data?.leFirstDate | excDate: 'dd.MM.yyyy'}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('OutLastDate')}}</span>
				<span>{{ServiceRecordSummary?.serviceRecordDetails?.data?.leLastDate | excDate: 'dd.MM.yyyy'}}</span>
				<q></q>
			</ng-container>
			<ng-container *ngIf="ServiceRecordSummary?.serviceRecordDetails?.data?.leState === 5">
				<span class="typo-small">{{getRessource('Auditor')}}</span>
				<span>{{ServiceRecordSummary?.serviceRecordDetails?.data?.lePickU}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('InAuditionSince')}}</span>
				<span>{{ServiceRecordSummary?.serviceRecordDetails?.data?.lePickD | excDate: 'dd.MM.yyyy'}}</span>
				<q></q>
			</ng-container>
			<ng-container *ngIf="!ServiceRecordSummary?.foreignData?.isEmpty">
				<span class="typo-small">{{getRessource('OutNum')}}</span>
				<span>{{ServiceRecordSummary?.serviceRecordDetails?.data?.leFKType === 'Vorgang' ? ServiceRecordSummary?.foreignData?.data?.vorgNr : ServiceRecordSummary?.foreignData?.data?.auNr}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('OutAuftraggeber')}}</span>
				<span>{{ServiceRecordSummary?.foreignData?.data?.auAuftraggeberShort}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('OutDmgNr')}}</span>
				<span>{{ServiceRecordSummary?.foreignData?.data?.aueSchadenNr}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('OutAuftragsdatum')}}</span>
				<span>{{ServiceRecordSummary?.foreignData?.data?.aueAuftragsdatum | excDate: 'dd.MM.yyyy'}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('OutProv')}}</span>
				<span>{{ServiceRecordSummary?.foreignData?.data?.aueLetzterSachverstaendiger}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('OutRechnung')}}</span>
				<span>{{ServiceRecordSummary?.foreignData?.data?.aueSchadensumme | excCurrency: '€'}}</span>
				<q></q>
				<span class="typo-small">{{getRessource('OutDmgOrt')}}</span>
				<span>{{ServiceRecordSummary?.foreignData?.data?.aueSchadenOrt}}</span>
				<q></q>
			</ng-container>
		</div>
		<div class="search-filter-seperator"></div>
	</div>

	<div class="content app-subarea">
		<div *ngIf="!ServiceRecordSummary?.isLoading && ServiceRecordSummary?.positionList?.data?.length === 0" class="splash empty">
			<p>{{getRessource('Es wurden keine Daten gefunden!')}}</p>
		</div>
		<exg-data-list #VCLeistungenListe
		               *ngIf="ServiceRecordSummary?.positionList?.data?.length > 0"
		               selectKey="lstgCreateNr"
		               [displayState]="0"
		               [rowSource]="ServiceRecordSummary?.positionList?.data">
			<ng-template #rowTemplate let-lstg>
				<div class="list-row list-row-auto-1-auto typo-small">
					<div style="padding-right:0.75rem">
						<i class="{{getTranslation('Icons.ServiceRecordType.' + lstg.lstgType)}}"
						   [tooltip]="lstg.lstgType" flow="right"></i>
					</div>
					<div>
						<div class="list-primary-text">{{lstg.lstgDescription}}</div>
						<div class="list-secondary-text">
							{{lstg.lstgDate | excDate: 'dd.MM.yyyy'}}
							<ng-container *ngIf="lstg.lstgErbringer"> - {{lstg.lstgErbringer}}</ng-container>
						</div>
					</div>
					<div class="list-metadata">
						<div class="typo-right">{{lstg.lstgAmount}} {{lstg.lstgUnit}}</div>
						<div class="typo-right"><strong>{{rowTotal(lstg) | excCurrency: '€'}}</strong></div>
						<div class="typo-right" *ngIf="isEditingAllowed(lstg) && !lstg.lstgDEL">
							<i class="search-filter-action fal fa-pen"
							   (click)="managePosition(lstg)"
							   [tooltip]="getRessource('EditPosition')" flow="left"></i>
							<i class="search-filter-action fal fa-ban"
							   (click)="deletePosition(lstg)"
							   [tooltip]="getRessource('DeletePosition')" flow="left"></i>
						</div>
					</div>
				</div>
			</ng-template>
		</exg-data-list>
	</div>

	<div class="app-space-right" *ngIf="!ServiceRecordSummary?.serviceRecordDetails?.isEmpty">
<!--		<div class="search-filter-seperator"></div>-->
		<div class="typo-container-s-s-q typo-small">
			<span class="typo-small">{{getRessource('FeeBasedService')}}</span>
			<span class="typo-right">{{ServiceRecordSummary?.serviceRecordDetails?.data?.leHonorarleistungSum | excCurrency: '€'}}</span>
			<q></q>
			<span class="typo-small">{{getRessource('TravelCosts')}}</span>
			<span class="typo-right">{{ServiceRecordSummary?.serviceRecordDetails?.data?.leFahrtkostenSum | excCurrency: '€'}}</span>
			<q></q>
			<span class="typo-small">{{getRessource('OtherCosts')}}</span>
			<span class="typo-right">{{ServiceRecordSummary?.serviceRecordDetails?.data?.leSonstigeKostenSum | excCurrency: '€'}}</span>
			<q></q>
			<span class="typo-small">{{getRessource('Expenses')}}</span>
			<span class="typo-right">{{ServiceRecordSummary?.serviceRecordDetails?.data?.leAuslagenSum | excCurrency: '€'}}</span>
			<q></q>
			<span class="typo-small"><strong>{{getRessource('SumTotal')}}</strong></span>
			<span class="typo-right"><strong>{{sumTotal() | excCurrency: '€'}}</strong></span>
			<q></q>
		</div>
	</div>
</div>
<div class="md3-card-on-surface app-space-top app-height-auto app-drawer" style="overflow: visible">
<!--	<i class="search-filter-seperator"></i>-->
	<i class="search-filter-action fal fa-check"
	   *ngIf="canFinish()"
	   (click)="changeState(finishTarget())"
	   [tooltip]="getRessource('StateAction.' + finishTarget())" flow="left"></i>
	<i class="search-filter-action fal fa-user-check"
	   *ngIf="canPick()"
	   (click)="pick()"
	   [tooltip]="getRessource('Pick')" flow="left"></i>
	<i class="search-filter-action fal fa-check"
	   *ngIf="isAuditor()"
	   [class.disabled]="!canAudit()"
	   (click)="canAudit() && changeState(10)"
	   [tooltip]="getRessource('StateAction.10')" flow="left"></i>
	<i class="search-filter-action fal fa-xmark"
	   *ngIf="isAuditor()"
	   [class.disabled]="!canAudit()"
	   (click)="canAudit() && changeState(2)"
	   [tooltip]="getRessource('StateAction.2')" flow="left"></i>
	<i class="search-filter-seperator"></i>
	<i class="search-filter-action fal fa-plus"
	   *ngIf="isEditingAllowed()"
	   (click)="managePosition()"
	   [tooltip]="getRessource('AddPosition')" flow="left"></i>
	<i class="search-filter-action fal fa-pen"
	   *ngIf="canRename()"
	   (click)="rename()"
	   [tooltip]="getGlobal('Rename')" flow="left"></i>
	<i class="search-filter-seperator"></i>
	<i class="search-filter-action fal fa-file-pdf"
	   (click)="generateReport()"
	   [tooltip]="getRessource('Report')" flow="left"></i>
	<i class="search-filter-action fal fa-paperclip"
	   (click)="openAttachments()"
	   [tooltip]="getRessource('Attachments')" flow="left"></i>
	<i class="search-filter-action fal fa-comments"
	   (click)="openCommentaryModal()"
	   [tooltip]="getRessource('Chat')" flow="left"></i>
	<i class="search-filter-action fal fa-history"
	   (click)="showHistory()"
	   [tooltip]="'Historie'" flow="left"></i>
	<i class="search-filter-seperator"></i>
</div>
</div>
